import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType, ChartTimerName } from '@frontend/chart/types';

import { TRANSACTION_TIMERS_DURATION_CHART_ENDPOINT } from '../transaction-chart-endpoints';

export const TRANSACTION_TIMER_DROP_OFF_PENDING_DURATION_METRIC_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.TRANSACTION_TIMER_DROP_OFF_PENDING_DURATION_METRIC,
    chartType: ChartRendererType.METRIC,
    endpoint: TRANSACTION_TIMERS_DURATION_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.NAME, value: ChartTimerName.TRANSACTION_DROP_OFF_PENDING },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.MONTH }
    ]
};
